"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteProviderData = exports.providerData = exports.groupData = void 0;
var individualData = [{
  id: 0,
  name: 'Teen 1'
}, {
  id: 1,
  name: 'Teen 2'
}, {
  id: 2,
  name: 'Teen 3'
}];
var groupData = exports.groupData = [{
  id: 0,
  name: 'Group 1',
  numStudents: 5,
  currentSession: 5,
  complete: true,
  archived: false,
  participants: individualData
}, {
  id: 1,
  name: 'Group 2',
  numStudents: 4,
  currentSession: 5,
  complete: true,
  archived: false,
  participants: individualData
}, {
  id: 2,
  name: 'Group 3',
  numStudents: 6,
  currentSession: 2,
  complete: false,
  archived: false,
  participants: individualData
}, {
  id: 3,
  name: 'Group 4',
  numStudents: 5,
  currentSession: 4,
  complete: false,
  archived: false,
  participants: individualData
}, {
  id: 4,
  name: 'Group 5',
  numStudents: 4,
  currentSession: 1,
  complete: false,
  archived: false,
  participants: individualData
}, {
  id: 5,
  name: 'Group 6',
  numStudents: 5,
  currentSession: 5,
  complete: true,
  archived: true,
  participants: individualData
}, {
  id: 6,
  name: 'Group 7',
  numStudents: 7,
  currentSession: 4,
  complete: false,
  archived: true,
  participants: individualData
}];
var providerData = exports.providerData = [{
  id: 100,
  name: 'Provider A',
  groups: groupData
}, {
  id: 110,
  name: 'Provider B',
  groups: [{
    id: 10,
    name: 'Group 10',
    numStudents: 5,
    currentSession: 5,
    complete: false,
    archived: false
  }, {
    id: 11,
    name: 'Group 11',
    numStudents: 4,
    currentSession: 5,
    complete: true,
    archived: false
  }]
}];
var siteProviderData = exports.siteProviderData = [{
  id: 1000,
  name: 'Site 1',
  providers: providerData,
  groups: [{
    id: 10,
    name: 'Group 10',
    numStudents: 5,
    currentSession: 5,
    complete: false,
    archived: false
  }, {
    id: 11,
    name: 'Group 11',
    numStudents: 4,
    currentSession: 5,
    complete: true,
    archived: false
  }]
}];